/* yn-home.js - the home route (package B). Plain JS, no library.
   Hero slides + position pills - shop-by-age chips - product row (size filter) -
   story signature motion - shop the look (hotspots, one size, get the whole look).
   Reads the shared core (window.Yuno) and the motion kit (window.YK), and degrades without them. */
(function () {
  'use strict';
  if (window.__ynHome) return;
  window.__ynHome = true;

  var doc = document;
  var html = doc.documentElement;
  var OUT = 'cubic-bezier(.2,.8,.2,1)';
  var SPRING = 'cubic-bezier(.3,1.4,.5,1)';

  /* ---------- small helpers ---------- */
  function qs(r, s) { return r.querySelector(s); }
  function qsa(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }
  var mqReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function reduced() { return !!mqReduce.matches || html.classList.contains('yn-reduced'); }
  /* motion gate: 'answer' (always unless reduced), 'charm' (level 2), 'up' (level 2 with the upgrades) */
  function ok(kind) { if (reduced()) return false; var K = window.YK; return K && K.ok ? K.ok(kind) : true; }
  function upgradesOn() { var Y = window.Yuno; return !(Y && Y.config && Y.config.upgrades === false); }
  function rtl() { return (doc.dir || html.getAttribute('dir') || '').toLowerCase() === 'rtl'; }
  function animate(el, frames, opts) {
    if (!el || !el.animate) return null;
    try { return el.animate(frames, opts); } catch (e) { return null; }
  }
  function onMq(mq, fn) { if (!mq) return; if (mq.addEventListener) mq.addEventListener('change', fn); else if (mq.addListener) mq.addListener(fn); }

  function money(c) {
    var Y = window.Yuno;
    if (Y && Y.money) return Y.money(c);
    return 'LE ' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' EGP';
  }
  function getSize() {
    try {
      var Y = window.Yuno;
      if (Y && Y.size && Y.size.get) return Y.size.get() || null;
      return localStorage.getItem('yuno-age') || null;
    } catch (e) { return null; }
  }
  function setSize(v) {
    var Y = window.Yuno;
    if (Y && Y.size && Y.size.set) { Y.size.set(v || null); return; }
    try { if (v) localStorage.setItem('yuno-age', v); else localStorage.removeItem('yuno-age'); } catch (e) {}
    doc.dispatchEvent(new CustomEvent('yuno:size', { detail: { size: v || null } }));
  }
  /* one document listener; each component registers a callback tied to its element */
  var sizeSubs = [];
  function onSize(el, fn) { sizeSubs.push({ el: el, fn: fn }); }
  doc.addEventListener('yuno:size', function (e) {
    var s = e.detail && 'size' in e.detail ? e.detail.size : getSize();
    sizeSubs = sizeSubs.filter(function (x) { return doc.contains(x.el); });
    sizeSubs.forEach(function (x) { x.fn(s || null); });
  });
  function tpl(s, vars) {
    s = s || '';
    for (var k in vars) { if (Object.prototype.hasOwnProperty.call(vars, k)) s = s.split('{' + k + '}').join(vars[k]); }
    return s;
  }
  /* T('Text') is the string in the visitor's language (English in sentence case when there is no translation).
     A size label such as '2-3 years' is a key everywhere in the code and is only translated where it is shown: T(size). */
  function T(s, p) {
    var Y = window.Yuno;
    if (Y && Y.T) return Y.T(s, p);
    if (p) for (var k in p) s = s.split('[' + k + ']').join(p[k]);
    return s;
  }

  /* ---------- motion: the shared kit does the drawing, the springs and the buddy's eyes ---------- */
  function kit(name) { var K = window.YK; return K && K[name] ? K : null; }
  function press(el) { var K = kit('press'); if (K) K.press(el); }
  function pop(el, big) { var K = kit('pop'); if (K) K.pop(el, big); }
  function shake(el, px) { var K = kit('shake'); if (K) K.shake(el, px); }
  function boil(el) { var K = kit('boilText'); if (K) K.boilText(el); }
  function land(els) { var K = kit('land'); if (K) K.land(els.slice(0, 4)); }
  function drawLine(svg, delay) { var K = kit('drawLine'); if (K && svg) K.drawLine(svg, delay); }
  function hideLine(svg) { var K = kit('hideLine'); if (K && svg) K.hideLine(svg); }
  function chipPop(el) { if (el && ok('answer')) animate(el, [{ transform: 'scale(.94)' }, { transform: 'scale(1.04) rotate(-1deg)' }, { transform: 'rotate(-1deg)' }], { duration: 180, easing: SPRING }); }

  /* the buddy: rises over an edge (my wrapper moves), its eyes look (the kit moves them) */
  function peek(el, o) {
    o = o || {};
    var dir = rtl() ? -1 : 1;
    var off = o.from === 'bottom' ? 'translateY(105%)' : o.from === 'start' ? 'translateX(' + (-105 * dir) + '%)' : 'translateX(' + (105 * dir) + '%)';
    var a = animate(el, [{ transform: off + ' rotate(0deg)' }, { transform: (o.rest || 'translateY(0)') + ' rotate(' + (o.tilt == null ? -6 : o.tilt) + 'deg)' }], { duration: 520, delay: o.delay || 0, easing: SPRING, fill: 'both' });
    return a && a.finished ? a.finished.catch(function () {}) : Promise.resolve();
  }
  function svgOf(host) { return qs(host, '[data-yn-buddy]') || host; }
  function look(host, dx, dy, ms) { var s = svgOf(host), K = kit('buddy'); if (K && s.__yk) K.buddy.look(s, dx, dy, ms); }
  function lookAt(host, el) { var s = svgOf(host), K = kit('buddy'); if (K && s.__yk && el) K.buddy.lookAt(s, el); }
  function busy(host, on) { var s = svgOf(host); if (s.__yk) s.__yk.busy = !!on; }

  /* ======================================================================
     Hero: crossfading slides, a pill that fills while a slide's time runs,
     a slow drift, swipe, touch pauses. A split slide is one slide on
     desktop (two photos side by side) and two slides on phones.
     ====================================================================== */
  function initHero(root) {
    if (root.__ynHero) return; root.__ynHero = true;
    var slides = qsa(root, '[data-yn-slide]');
    var pills = qsa(root, '[data-yn-hero-pill]');
    var fills = pills.map(function (p) { return qs(p, '.yn-hero__fill'); });
    var secs = parseFloat(root.getAttribute('data-seconds')); if (isNaN(secs)) secs = 6;
    var dur = secs * 1000;
    var mqD = window.matchMedia ? window.matchMedia('(min-width: 990px)') : { matches: false };
    var steps = [], cur = 0, fillAnim = null, drifts = [], drifted = false, dead = false;
    var hold = false, hover = false, focus = false, inView = true, hx = null;

    function build() {
      steps = [];
      slides.forEach(function (s, i) {
        var sub = mqD.matches && s.getAttribute('data-role') === 'b' && steps.length;
        if (pills[i]) pills[i].classList.toggle('is-sub', !!sub);
        if (sub) steps[steps.length - 1].els.push(s);
        else steps.push({ els: [s], pill: pills[i] || null, fill: fills[i] || null });
      });
      root.classList.toggle('yn-hero--single', steps.length < 2);
    }
    function show(i) {
      cur = i;
      slides.forEach(function (s) {
        var on = steps[i].els.indexOf(s) > -1;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      pills.forEach(function (p) { p.removeAttribute('aria-current'); });
      if (steps[i].pill) steps[i].pill.setAttribute('aria-current', 'true');
      root.classList.add('is-ready');
    }
    function stop() {
      if (fillAnim) { fillAnim.onfinish = null; fillAnim.cancel(); fillAnim = null; }
      drifts.forEach(function (a) { a.cancel(); }); drifts = [];
      fills.forEach(function (f) { if (!f) return; if (f.getAnimations) f.getAnimations().forEach(function (a) { a.cancel(); }); f.style.transform = 'scaleX(0)'; });
    }
    function paused() { return hold || hover || focus || !inView || doc.hidden; }
    function applyPause() {
      var p = paused();
      [fillAnim].concat(drifts).forEach(function (a) {
        if (!a) return;
        if (p && a.playState === 'running') a.pause();
        else if (!p && a.playState === 'paused') a.play();
      });
    }
    function start(i) {
      if (dead) return;
      stop(); show(i);
      var st = steps[i], autoplay = steps.length > 1 && dur > 0 && !reduced();
      if (autoplay) {
        fillAnim = animate(st.fill, [{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], { duration: dur, easing: 'linear', fill: 'forwards' });
        if (fillAnim) fillAnim.onfinish = function () { start((i + 1) % steps.length); };
        else if (st.fill) st.fill.style.transform = 'scaleX(1)';
      } else if (st.fill) st.fill.style.transform = 'scaleX(1)';
      if (ok('charm')) {
        st.els.forEach(function (s) { // slow drift 1.00 -> 1.04 over the slide's time on screen (the first waits a moment)
          var a = animate(qs(s, 'img'), [{ transform: 'scale(1)' }, { transform: 'scale(1.04)' }], { duration: (dur || 6000) + 800, delay: drifted ? 0 : 800, easing: 'linear', fill: 'both' });
          if (a) drifts.push(a);
        });
        drifted = true;
      }
      applyPause();
    }
    function stepOfPill(p) { for (var i = 0; i < steps.length; i++) if (steps[i].pill === p) return i; return 0; }

    build();
    if (!steps.length) return;
    show(0);
    pills.forEach(function (p) { p.addEventListener('click', function () { start(stepOfPill(p)); }); });
    root.addEventListener('pointerdown', function (e) { hx = e.clientX; hold = true; applyPause(); });
    root.addEventListener('pointerup', function (e) {
      hold = false; applyPause();
      if (hx == null) return;
      var dx = e.clientX - hx; hx = null;
      if (Math.abs(dx) > 40 && steps.length > 1) start((cur + (dx < 0 ? 1 : -1) + steps.length) % steps.length);
    });
    root.addEventListener('pointercancel', function () { hold = false; hx = null; applyPause(); });
    root.addEventListener('mouseenter', function () { hover = true; applyPause(); });
    root.addEventListener('mouseleave', function () { hover = false; applyPause(); });
    root.addEventListener('focusin', function () { focus = true; applyPause(); });
    root.addEventListener('focusout', function () { focus = false; applyPause(); });
    doc.addEventListener('visibilitychange', applyPause);
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { inView = es[0].isIntersecting; applyPause(); }, { threshold: 0.1 }).observe(root);
    onMq(mqD, function () { build(); start(0); });
    onMq(mqReduce, function () { start(cur); });
    root.__ynCleanup = function () { dead = true; stop(); doc.removeEventListener('visibilitychange', applyPause); };

    /* decoration after first paint: the squiggle draws itself (kit), the button pops, the heading and squiggle boil, the buddy peeks */
    var btn = qs(root, '[data-yn-hero-btn]'), h = qs(root, '[data-yn-hero-h]'), sq = qs(root, '.yn-hero__squiggle'), b = qs(root, '[data-yn-hero-buddy]');
    function intro() {
      if (ok('charm') && btn) animate(btn, [{ transform: 'scale(.86)' }, { transform: 'scale(1)' }], { duration: 380, delay: 220, easing: SPRING, fill: 'backwards' });
      if (ok('up')) {
        if (h) setTimeout(function () { boil(h); }, 120);
        if (sq) setTimeout(function () { boil(sq); }, 800);
      }
      if (!b) return;
      if (!upgradesOn()) { b.parentNode.style.display = 'none'; return; }
      if (!ok('up')) { b.style.transform = 'translateY(0)'; return; } // reduced: the buddy simply sits there
      b.style.transform = 'translateY(105%)';
      busy(b, true);
      peek(b, { from: 'bottom', delay: 650, tilt: -6, rest: 'translateY(0)' }).then(function () {
        lookAt(b, btn);
        setTimeout(function () { busy(b, false); }, 2500);
      });
    }
    start(0);
    requestAnimationFrame(function () { setTimeout(intro, 0); });
  }

  /* ======================================================================
     Shop by age: six chips. The choice is the remembered size.
     ====================================================================== */
  function initAge(root) {
    if (root.__ynAge) return; root.__ynAge = true;
    var chips = qsa(root, '[data-yn-age-chip]');
    var note = qs(root, '[data-yn-age-note]');
    var tEmpty = root.getAttribute('data-note-empty') || '', tSet = root.getAttribute('data-note-set') || '';
    function sync(size) {
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-yn-age-chip') === size ? 'true' : 'false'); });
      if (note) note.textContent = size ? tpl(tSet, { size: T(size) }) : tEmpty;
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var label = c.getAttribute('data-yn-age-chip');
        var next = getSize() === label ? null : label;
        chipPop(next ? c : null);
        setSize(next);
        sync(getSize());
      });
    });
    onSize(root, sync);
    sync(getSize());
  }

  /* ======================================================================
     Product row: the remembered size hides what is not in stock in it.
     ====================================================================== */
  function initRow(root) {
    if (root.__ynRow) return; root.__ynRow = true;
    var row = qs(root, '[data-yn-row]'), count = qs(root, '[data-yn-row-count]');
    var items = qsa(root, '.yn-prow__item');
    var tAll = root.getAttribute('data-tpl-all') || '', tSize = root.getAttribute('data-tpl-size') || '', tNone = root.getAttribute('data-tpl-none') || '';
    var first = true;
    function apply(size) {
      var shown = [];
      items.forEach(function (it) {
        var card = qs(it, '[data-yn-card]');
        var sizes = card ? (card.getAttribute('data-sizes') || '').split('|') : [];
        var fits = !size || sizes.indexOf(size) > -1;
        it.hidden = !fits;
        if (fits) shown.push(it);
      });
      if (count) count.textContent = !size ? tAll : shown.length ? tpl(tSize, { n: shown.length, size: T(size) }) : tpl(tNone, { size: T(size) });
      if (!first && row) { row.scrollLeft = 0; land(shown); }
      first = false;
    }
    onSize(root, apply);
    apply(getSize());
  }

  /* ======================================================================
     Story: the homepage's signature moment. Once, as it enters: the buddy
     peeks in from the edge, its eyes follow the drawn line, the squiggle
     draws. The frame draws and boils through the kit. A line down the edge
     draws as you scroll. Reduced: all of it simply there.
     ====================================================================== */
  function initStory(root) {
    if (root.__ynStory) return; root.__ynStory = true;
    var b = qs(root, '[data-yn-story-buddy]'), sq = qs(root, '[data-yn-story-squiggle]'), line = qs(root, '[data-yn-story-line]'), fr = qs(root, '[data-yn-story-frame]');
    var charm = ok('charm'), dir = rtl() ? -1 : 1, cleanups = [];
    if (charm && sq && kit('hideLine')) hideLine(sq);
    if (charm && b) b.style.transform = 'translateX(' + (105 * dir) + '%)';
    if (charm && line) line.style.clipPath = 'inset(0 0 100% 0)';

    function signature() {
      if (!charm) return;
      if (b) {
        busy(b, true);
        peek(b, { from: 'end', delay: 120, tilt: -6, rest: 'translateX(0)' }).then(function () {
          [[-22, -12], [-22, 4], [-16, 14], [-22, 0]].forEach(function (p, k) { setTimeout(function () { look(b, p[0] * dir, p[1], 150); }, k * 170); });
          setTimeout(function () { drawLine(sq); }, 280);
          setTimeout(function () { look(b, 0, 0, 300); busy(b, false); }, 1100);
        });
      } else drawLine(sq);
      var K = kit('frame');
      if (fr && K) setTimeout(function () { try { K.frame.boil(fr, 500); } catch (e) {} }, 700);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); signature(); } }, { threshold: 0.18 });
      io.observe(root);
    } else signature();

    if (line && charm && 'IntersectionObserver' in window) { // the line down the edge draws as the section scrolls through
      var near = false, tick = false;
      var upd = function () {
        tick = false;
        var r = root.getBoundingClientRect(), vh = window.innerHeight || html.clientHeight;
        var p = Math.max(0, Math.min(1, (vh - r.top) / (r.height + vh * 0.4)));
        line.style.clipPath = 'inset(0 0 ' + ((1 - p) * 100).toFixed(2) + '% 0)';
      };
      var onS = function () { if (!tick) { tick = true; requestAnimationFrame(upd); } };
      var io2 = new IntersectionObserver(function (es) {
        var v = es[0].isIntersecting;
        if (v && !near) { near = true; window.addEventListener('scroll', onS, { passive: true }); window.addEventListener('resize', onS); onS(); }
        else if (!v && near) { near = false; window.removeEventListener('scroll', onS); window.removeEventListener('resize', onS); upd(); }
      }, { rootMargin: '100px 0px' });
      io2.observe(root);
      cleanups.push(function () { io2.disconnect(); window.removeEventListener('scroll', onS); window.removeEventListener('resize', onS); });
    }
    root.__ynCleanup = function () { cleanups.forEach(function (f) { f(); }); };
  }

  /* ======================================================================
     Shop the look: hotspots open a piece (name, price, add); one size
     covers the look; "get the whole look" adds every piece in that size.
     ====================================================================== */
  function initLooks(sec) {
    if (sec.__ynLooks) return; sec.__ynLooks = true;
    var strings = {};
    try { strings = JSON.parse(qs(sec, '[data-yn-look-strings]').textContent) || {}; } catch (e) {}
    /* S('low', {...}): the wording the section printed (already in the visitor's language), with {n} {size} {total} filled in */
    function S(k, vars) {
      var v = vars;
      if (vars && vars.size) { v = {}; for (var x in vars) { if (Object.prototype.hasOwnProperty.call(vars, x)) v[x] = vars[x]; } v.size = T(vars.size); }
      return tpl(strings[k], v);
    }
    var eg = sec.getAttribute('data-eg') === 'true';
    var showNote = sec.getAttribute('data-show-note') !== 'false';
    var cfg = (window.Yuno && window.Yuno.config) || {};
    var threshold = cfg.threshold || parseInt(sec.getAttribute('data-threshold'), 10) || 0;
    var lowStock = cfg.lowStock || 5;
    var tabs = qsa(sec, '[data-yn-look-tab]');
    var state = { size: getSize(), active: 0, tapped: false, add: { look: null, src: null, phase: 'idle', msg: '' } };
    var visible = true, pulseT = null;

    var looks = qsa(sec, '[data-yn-look]').map(function (el) {
      var data = { pieces: [] };
      try { data = JSON.parse(qs(el, '[data-yn-look-json]').textContent) || data; } catch (e) {}
      return {
        el: el, pieces: data.pieces || [], photo: qs(el, '[data-yn-look-photo]'), pop: qs(el, '[data-yn-pop]'),
        hs: qsa(el, '[data-yn-hs]'), chips: qsa(el, '[data-yn-look-chip]'), rows: qsa(el, '[data-yn-row-i]'),
        go: qs(el, '[data-yn-look-go]'), goLabel: qs(el, '[data-yn-go-label]'), note: qs(el, '[data-yn-look-note]'),
        sizesRow: qs(el, '[data-yn-look-sizes]'), open: null, calc: [], total: 0, count: 0
      };
    });
    if (!looks.length) return;

    /* which variant covers a piece in a size: the first one in stock, else the first */
    function pick(p, size) {
      if (!size && !p.ns) return null;
      var best = null;
      for (var i = 0; i < p.v.length; i++) {
        var r = p.v[i];
        if (!p.ns && r[0] !== size) continue;
        if (!best || (r[2] && !best[2])) best = r;
      }
      return best;
    }
    function compute(L) {
      var s = state.size; L.total = 0; L.count = 0;
      L.calc = L.pieces.map(function (p) {
        var v = pick(p, s), fits = !!(v && v[2]), st, cls = '';
        if (!s && !p.ns) st = S('pick');
        else if (fits) { st = (v[3] > 0 && v[3] <= lowStock) ? S('low', { n: v[3], size: s }) : (p.ns ? T('In stock') : S('in', { size: s })); cls = 'is-ok'; }
        else { st = S('out', { size: s || '' }); cls = 'is-bad'; }
        if (fits) { L.total += p.p; L.count++; }
        return { p: p, v: v, ok: fits, st: st, cls: cls };
      });
    }
    function phaseOf(L, src) { return state.add.look === L && state.add.src === src ? state.add.phase : 'idle'; }
    function setBtn(btn, ph, disabled) {
      btn.classList.toggle('is-loading', ph === 'loading');
      btn.classList.toggle('is-done', ph === 'success');
      btn.classList.toggle('is-error', ph === 'error');
      btn.setAttribute('aria-disabled', ph === 'idle' && disabled ? 'true' : 'false');
    }
    function goLabel(L) {
      var s = state.size, n = L.calc.length;
      if (!s) return S('choose');
      if (L.count === 0) return S('none', { size: s });
      if (L.count === n) return S('all', { total: money(L.total) });
      return L.count === 1 ? S('one', { size: s, total: money(L.total) }) : S('many', { n: L.count, size: s, total: money(L.total) });
    }
    function fillPop(L) {
      var c = L.calc[L.open]; if (!c) return;
      var p = c.p, el = L.pop, ph = phaseOf(L, 'pop');
      el.setAttribute('aria-label', p.t);
      var img = qs(el, '[data-yn-pop-img]'); if (img && p.m && img.getAttribute('src') !== p.m) img.src = p.m;
      var tt = qs(el, '[data-yn-pop-title]'); tt.textContent = p.t; tt.setAttribute('href', p.u || '#');
      qs(el, '[data-yn-pop-now]').textContent = money(p.p);
      var was = qs(el, '[data-yn-pop-was]'); was.textContent = p.c ? money(p.c) : ''; was.hidden = !p.c;
      var st = qs(el, '[data-yn-pop-status]'); st.textContent = c.st; st.className = 'yn-look__pop-status ' + c.cls;
      var s = state.size, usable = !!(s || p.ns) && c.ok;
      qs(el, '[data-yn-pop-label]').textContent = ph === 'loading' ? S('adding') : ph === 'success' ? S('added') : ph === 'error' ? S('retry') : !s && !p.ns ? S('popChoose') : c.ok ? S('popAdd', { size: s || '' }) : S('popNone', { size: s });
      setBtn(qs(el, '[data-yn-pop-add]'), ph, !usable);
    }
    function render(L) {
      compute(L);
      L.chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-yn-look-chip') === state.size ? 'true' : 'false'); });
      L.rows.forEach(function (r, i) {
        var c = L.calc[i], st = qs(r, '[data-yn-look-status]'); if (!c || !st) return;
        st.textContent = c.st; st.className = 'yn-look__status ' + c.cls;
      });
      var ph = phaseOf(L, 'look');
      L.goLabel.textContent = ph === 'loading' ? S('adding') : ph === 'success' ? S('added') : ph === 'error' ? S('retry') : goLabel(L);
      setBtn(L.go, ph, !state.size || L.count === 0);
      var err = state.add.phase === 'error' && state.add.look === L;
      if (err) L.note.textContent = state.add.msg;
      else if (eg && showNote) L.note.textContent = S('noteBase', { threshold: money(threshold) }) + (L.count ? ' ' + S('noteLook', { total: money(L.total) }) : '');
      else L.note.textContent = '';
      L.note.classList.toggle('is-error', err);
      if (L.open != null) fillPop(L);
    }
    function renderAll() { looks.forEach(render); }
    function centreChip(L) { // keep the chosen size in view when the row scrolls sideways
      var row = L.sizesRow, chip = row && qs(row, '[aria-pressed="true"]');
      if (!chip || !row.clientWidth || row.scrollWidth <= row.clientWidth + 1) return;
      var left = chip.getBoundingClientRect().left - row.getBoundingClientRect().left + row.scrollLeft - (row.clientWidth - chip.offsetWidth) / 2;
      if (row.scrollTo) row.scrollTo({ left: left, behavior: ok('answer') ? 'smooth' : 'auto' }); else row.scrollLeft = left;
    }

    /* hotspots, and the card that grows out of them */
    function popIn(L, i) {
      var el = L.pop, dot = L.hs[i]; if (!el || !dot) return;
      var a = el.getBoundingClientRect(), b = dot.getBoundingClientRect();
      el.style.transformOrigin = (b.left + b.width / 2 - a.left) + 'px ' + (b.top + b.height / 2 - a.top) + 'px';
      if (ok('up')) animate(el, [{ transform: 'scale(.08)', opacity: 0 }, { transform: 'scale(1)', opacity: 1 }], { duration: 300, easing: SPRING });
      else if (ok('answer')) animate(el, [{ opacity: 0 }, { opacity: 1 }], { duration: 180 });
    }
    function closePop(L, refocus) {
      if (L.open == null) return;
      var i = L.open; L.open = null; L.pop.hidden = true;
      L.hs.forEach(function (h) { h.setAttribute('aria-expanded', 'false'); });
      if (refocus && L.hs[i]) L.hs[i].focus();
    }
    function openPop(L, i) {
      state.tapped = true; stopPulse();
      if (L.open === i) { closePop(L); return; }
      var was = L.open != null;
      L.open = i;
      L.hs.forEach(function (h, k) { h.setAttribute('aria-expanded', k === i ? 'true' : 'false'); });
      L.pop.hidden = false; fillPop(L);
      if (!was) popIn(L, i);
      var ring = qs(L.hs[i], '[data-yn-ring]');
      if (ring && ok('answer')) animate(ring, [{ transform: 'scale(1)', opacity: .9 }, { transform: 'scale(2.2)', opacity: 0 }], { duration: 500, easing: OUT });
    }
    function startPulse() { // hotspots pulse one after another until the first tap
      stopPulse(); if (!ok('up')) return;
      var i = 0;
      pulseT = setInterval(function () {
        if (state.tapped) { stopPulse(); return; }
        if (!visible || doc.hidden) return;
        var rings = qsa(looks[state.active].el, '[data-yn-ring]'), r = rings[i % (rings.length || 1)];
        i++;
        if (r) animate(r, [{ transform: 'scale(1)', opacity: .9 }, { transform: 'scale(2.2)', opacity: 0 }], { duration: 1100, easing: OUT });
      }, 1300);
    }
    function stopPulse() { if (pulseT) { clearInterval(pulseT); pulseT = null; } }

    /* adding: pressed, three dots, a tick and "added!" for a moment, a photo flies to the cart, then a toast */
    function cartMark() {
      var list = qsa(doc, '[data-yn-cart-open]');
      for (var i = 0; i < list.length; i++) {
        var r = list[i].getBoundingClientRect();
        if (r.width > 0 && r.height > 0 && r.top >= -2 && r.bottom <= window.innerHeight + 2) return list[i];
      }
      return null;
    }
    function doAdd(L, src, items, photo, total) {
      if (state.add.phase === 'loading') return;
      var Y = window.Yuno, btn = src === 'pop' ? qs(L.pop, '[data-yn-pop-add]') : L.go, size = state.size;
      press(btn);
      state.add = { look: L, src: src, phase: 'loading', msg: '' }; render(L);
      var req = Y && Y.cart && Y.cart.add ? Y.cart.add(items, { source: 'look' }) : Promise.reject(new Error(S('error')));
      req.then(function () {
        state.add = { look: L, src: src, phase: 'success', msg: '' }; render(L);
        if (Y && Y.announce) Y.announce(S('added'));
        var K = kit('fly'), to = cartMark();
        if (K && to && photo && ok('up')) K.fly(btn, to, photo);
        setTimeout(function () {
          state.add = { look: null, src: null, phase: 'idle', msg: '' };
          if (src === 'pop') closePop(L);
          renderAll();
          if (Y && Y.toast) Y.toast(S('added'), { photo: photo, sub: money(total) + ' · ' + T(size), actionLabel: S('toastView'), onAction: function () { if (Y.cart && Y.cart.open) Y.cart.open(); } });
        }, 600);
      }).catch(function (err) {
        var msg = typeof err === 'string' ? err : (err && err.message) || '';
        state.add = { look: L, src: src, phase: 'error', msg: msg || S('error') }; render(L);
        shake(btn, 4);
      });
    }

    looks.forEach(function (L) {
      L.chips.forEach(function (c) { c.addEventListener('click', function () { state.size = c.getAttribute('data-yn-look-chip'); chipPop(c); renderAll(); centreChip(L); }); });
      L.hs.forEach(function (h, i) { h.addEventListener('click', function (e) { e.stopPropagation(); openPop(L, i); }); });
      L.photo.addEventListener('click', function (e) { if (L.open != null && !e.target.closest('[data-yn-hs],[data-yn-pop]')) closePop(L); });
      qs(L.pop, '[data-yn-pop-close]').addEventListener('click', function () { closePop(L, true); });
      qs(L.pop, '[data-yn-pop-add]').addEventListener('click', function () {
        if (L.open == null) return;
        var c = L.calc[L.open];
        if (!state.size && !c.p.ns) { shake(L.sizesRow, 4); return; }
        if (!c.ok) { shake(qs(L.pop, '[data-yn-pop-add]'), 3); return; }
        doAdd(L, 'pop', [{ id: c.v[1], quantity: 1 }], c.p.m, c.p.p);
      });
      L.go.addEventListener('click', function () {
        if (!state.size) { shake(L.sizesRow, 4); return; }
        var fit = L.calc.filter(function (c) { return c.ok; });
        if (!fit.length) { shake(L.go, 3); return; }
        doAdd(L, 'look', fit.map(function (c) { return { id: c.v[1], quantity: 1 }; }), fit[0].p.m, L.total);
      });
    });
    doc.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !doc.contains(sec)) return;
      looks.forEach(function (L) { if (L.open != null) closePop(L, true); });
    });

    /* several looks: tabs swap the photo and the pieces; the size stays */
    function setActive(i) {
      state.active = i;
      looks.forEach(function (L, k) { if (k !== i) closePop(L); L.el.hidden = k !== i; });
      tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      render(looks[i]); centreChip(looks[i]);
      if (ok('answer')) animate(looks[i].el, [{ opacity: 0 }, { opacity: 1 }], { duration: 260, easing: OUT });
    }
    tabs.forEach(function (t, i) { t.addEventListener('click', function () { setActive(i); }); });

    onSize(sec, function (s) { if (s) { state.size = s; renderAll(); looks.forEach(centreChip); } });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0.2 }).observe(sec);
    renderAll(); looks.forEach(centreChip); startPulse();
    sec.__ynCleanup = function () { stopPulse(); };
  }

  /* ---------- start, and start again when the theme editor reloads a section ---------- */
  var MAP = [
    ['[data-yn-hero]', initHero], ['[data-yn-home-age]', initAge], ['[data-yn-prow]', initRow],
    ['[data-yn-story]', initStory], ['[data-yn-looks]', initLooks]
  ];
  function initAll(root) {
    MAP.forEach(function (m) {
      var list = qsa(root, m[0]);
      if (root.matches && root.matches(m[0])) list.unshift(root);
      list.forEach(function (el) { try { m[1](el); } catch (e) { if (window.console) console.error('[yn-home]', e); } });
    });
  }
  initAll(doc);
  doc.addEventListener('shopify:section:load', function (e) { if (e.target) initAll(e.target); });
  doc.addEventListener('shopify:section:unload', function (e) {
    if (!e.target) return;
    qsa(e.target, '*').forEach(function (el) { if (el.__ynCleanup) { try { el.__ynCleanup(); } catch (x) {} } });
  });
})();
